module.exports = __webpack_public_path__ + "img/积分记录.f1a51846.jpg";